import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const putServiceSelection = async ({
  products,
  customerId,
  selectionId,
  appointmentId,
  devices,
  description,
  os,
  paymentMethod,
  serviceType,
  previousJob,
  warrantyReason,
  productAdditionalSelection,
  additionalProblem,
  noAutoAppend,
}: JsonDataItem) => {
  const { data } = await baseQuery('service-selection', {
    type: 'PUT',
    body: {
      product_selection: products,
      service_selection_id: selectionId,
      hold_appointment_id: appointmentId,
      customer_id: customerId,
      device_selection: devices,
      description,
      additional_problem: additionalProblem,
      os_selection: os,
      payment_method: paymentMethod,
      service_attributes: {
        job_service_type: serviceType,
        previous_job_id: previousJob,
        warranty_reason_id: warrantyReason,
      },
      product_additional_selection: productAdditionalSelection,
      no_auto_append_description: Number(!!noAutoAppend),
    },
  });

  return data;
};
